<template>
  <div class="bannerW">
    <el-image :src="bannerInfo.PicUrl" fit="cover" class="banner"
      ><div slot="placeholder" class="image-slot"></div>
      <div slot="error" class="image-error-slot">
        <i class="el-icon-picture-outline"></i>
      </div>
    </el-image>
    <div class="titleBox" :class="{ bannerEn: lang == 'en' }">
      <h2>{{ bannerInfo.Title }}</h2>
      <p v-html="bannerInfo.SubTitle"></p>
    </div>
  </div>
</template>

<script>
import { changeText } from "@/utils/tool";

export default {
  data() {
    return {
      bannerInfo: {
        Title: "",
        PicUrl: "",
        SubTitle: "",
      },
      lang: this.$global.lang,
    };
  },
  props: ["classType"],
  methods: {
    changeValue(value) {
      return changeText(value);
    },
    getBanner() {
      this.$api
        .banner({
          Type: this.classType,
        })
        .then((res) => {
          this.bannerInfo = res.Value;
        });
    },
  },

  mounted() {
    this.getBanner();
  },
};
</script>

